export const signUpSignIn = {
  signUp: "Sign Up",
  inputPhone: "请输入手机号码",
  inputCorrectPhoneNumber: "请输入正确的手机号码",
  inputCode: "请输入验证码",
  getCode: "获取验证码",
  countSignIn: "账号登陆",
  codeSignIn: "验证码登陆",
  readAndAccept: "阅读并接受",
  pleaseReadAndAccept: "请先阅读并接受",
  userServicesAgreement: "《用户服务协议》",
  and: "及",
  registerSuccess: "注册成功，请登陆",
  privacyPolicy: "《FoxitHD隐私政策》",
  hasCountPlease: "已有账号，请",
  signIn: "登录",
  interval: "{count}秒后重新发送",
  phoneNumber: "手机号码",
  notHas: "还没有账号，请",
  password: "密码",
  forget: "忘记密码",
  code: "验证码",
  inputUsername: "请输入手机号/邮箱",
  usernameWrong: "请输入正确的手机号/邮箱"
};
